// Helpers de mensagem de erro de API (SISGASREC spec #75 / card 155).
// Regra: erro de regra de negocio ou validacao (HTTP < 500) tem mensagem
// propria vinda do backend e deve ser exibida ao usuario. Falha inesperada
// (5xx, rede, sem corpo) usa mensagem generica + referencia de suporte.

export const GENERIC_ERROR =
  'The operation could not be completed due to an unexpected error. ' +
  'Please try again or contact support with the reference below.';

// true quando a falha nao e previsivel (sem status, ou status >= 500).
export function isUnexpectedError(error) {
  const status = error && error.response && error.response.status;
  return !status || status >= 500;
}

// Extrai a mensagem de negocio/validacao do backend; null quando nao aplicavel.
export function businessMessage(error) {
  const response = error && error.response;
  const status = response && response.status;
  const data = response && response.data;

  if (status && status < 500 && data) {
    if (data.message) {
      return data.message;
    }
    if (status === 422 && data.errors) {
      const first = Object.values(data.errors)[0];
      if (Array.isArray(first) && first[0]) {
        return first[0];
      }
    }
  }
  return null;
}
